import { styled } from '@mui/material'

export const Root = styled('div')`
  padding: 16px 0 0;
`
